import { render, staticRenderFns } from "./VoucherArchiveDialog.vue?vue&type=template&id=4c65e3a5&scoped=true"
import script from "./VoucherArchiveDialog.vue?vue&type=script&lang=ts"
export * from "./VoucherArchiveDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65e3a5",
  null
  
)

export default component.exports